import TOOLS from '@helpers/tools'
import FILTERS from '@helpers/filters'

export default function productDataLayerBody(stateId, locations, imovel, path, type) {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({ imoveis: undefined })
    window.dataLayer.push({
      event: 'dados-imoveis',
      pagepath: path,
      pageType: type,
      estado: TOOLS.slugify(imovel.Localizacao.Estado),
      cidade: TOOLS.slugify(imovel.Localizacao.Cidade),
      imoveis: {
        id: imovel.imovelId,
        idFacilita: imovel.idFacilita,
        nome: TOOLS.slugify(imovel.Nome),
        bairro: TOOLS.slugify(imovel.Localizacao.Bairro),
        cidade: TOOLS.slugify(imovel.Localizacao.Cidade),
        estado: TOOLS.slugify(imovel.Localizacao.Estado),
        areaprivativa: imovel.AreaPrivativaM2 ? imovel.AreaPrivativaM2 : undefined,
        dormitorios: TOOLS.slugify(imovel.Quartos),
        vagas: imovel.VagasGaragem,
        valor: imovel.PrecoMinimo ? FILTERS.moneyBi(imovel.PrecoMinimo) : undefined,
        status: imovel.Status ? TOOLS.slugify(imovel.Status) : undefined,
        position: undefined,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/productDataLayer.js